import { Map } from 'immutable';
import { USER_LANGUAGES_BY_ID } from 'app/constants/enums/Language';
import { isLanguageProficiencyId } from 'app/constants/enums/LanguageProficiency';
import createErrorType from 'app/utils/createErrorType';

export class InvalidLanguageProficiencyError extends createErrorType('InvalidLanguageProficiencyError') {}

export class LanguageProficiencies {
  public constructor(public readonly data: Map<string, string>) {}

  public toJSON() {
    return this.data.toJS();
  }
}

const isStringToStringObject = (o: unknown): o is {[index: string]: string} => (
  typeof o === 'object' && o !== null && Object.keys(o).every(k => typeof k === 'string')
);

export const LanguageProficiencyMarshaller = {
  deserialize: (o: unknown) => {
    if (isStringToStringObject(o)) {
      for (const key in o) {
        if (o.hasOwnProperty(key)) {
          const value = o[key];
          if (USER_LANGUAGES_BY_ID.get(key) === undefined) {
            throw new InvalidLanguageProficiencyError(`Invalid language ${key}`);
          }
          if (!isLanguageProficiencyId(value)) {
            throw new InvalidLanguageProficiencyError(`Invalid language proficiency ${value}`);
          }
        }
      }
      return new LanguageProficiencies(Map<string, string>(o));
    } else {
      throw new InvalidLanguageProficiencyError(`Language proficiencies must be an object of strings, got ${o}`);
    }
  },
  serialize: (o: LanguageProficiencies) => o.toJSON(),
};
